import type { TaskView } from "../api/types";
import { cronInWords } from "./cron";
import { until } from "./format";

/**
 * A task with its schedule paused, or resumed if it already was.
 *
 * The server sends `enabled` only when it has it to send, and its own default is `true`, so a task
 * that arrives without the field is a running one and the first press pauses it.
 */
export function switched(task: TaskView): TaskView {
  return { ...task, enabled: task.enabled === false };
}

/**
 * What a task's row says about its schedule, or `""` for one that has none.
 *
 * A paused task has no next firing to report — the server leaves `nextFiringAt` null for it — so the
 * line says it is paused rather than going quiet, which reads the same as a task that simply has
 * nothing coming.
 *
 * @param task the task the row is for.
 * @param at what time it is, for the wait until the next firing.
 */
export function scheduleWords(task: TaskView, at: number): string {
  if (!task.cron) return "";

  // An expression this port cannot read is still the operator's own, so it is printed as written.
  const reading = cronInWords(task.cron) ?? task.cron;
  if (task.enabled === false) return `${reading} · paused`;
  if (!task.nextFiringAt) return reading;

  return `${reading} · next ${until(task.nextFiringAt, at)}`;
}
